import React, { useState } from "react";
import { Chip, ChipOption, ChipSizeEnum } from "../Chip/Chip";
import { darkenColor, StyledPercentageContent } from "./PercentageChip.styled";
import { DimensionsEnum, FontWeightEnum } from "../../../types/AppTypes";
import { BodyTyp } from "../../Typography/Typography";
import { ProgressBar } from "../ProgressBar/ProgressBar";
import { theme } from "../../../constants/StyledComponents";

export type PercentageOption<T> = ChipOption<T> & {
  percentage?: number;
};

type PercentageChipProps<T> = {
  option: PercentageOption<T>;
  selectedChip: boolean;
  onSelectChip: (value: T) => void;
  color?: string;
};

export const PercentageChip = <T,>({
  option,
  selectedChip,
  onSelectChip,
  color,
}: PercentageChipProps<T>) => {
  const [isHovered, setIsHovered] = useState(false);
  const isActive = selectedChip || isHovered;

  const content: ChipOption<T> = {
    value: option.value,
    label: (
      <StyledPercentageContent
        $color={color}
        $selectedChip={selectedChip}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <BodyTyp
          fontWeight={FontWeightEnum.MEDIUM}
          variant="3"
          color={selectedChip ? theme.colors.white : color}
        >
          {option.label}
          {option.percentage !== undefined ? ` ${option.percentage}%` : ""}
        </BodyTyp>
        {option.percentage !== undefined ? (
          <ProgressBar
            progress={option.percentage}
            visiblePercentage={false}
            color={color ? (isActive ? darkenColor(color, 30) : color) : ""}
            size={DimensionsEnum.SMALL}
          />
        ) : null}
      </StyledPercentageContent>
    ),
  };

  return (
    <Chip
      option={content}
      selectedChip={selectedChip}
      onSelectChip={onSelectChip}
      borderColor={color}
      size={ChipSizeEnum.BIG}
      textColor={theme.colors.black}
      hoverEffect
      hoverBackgroundColor={color}
    />
  );
};
